// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"729":"0bd9ffd88332afe7","1435":"edcfaf568248bf3d"}[chunkId] + ".css";
};